module.exports = __webpack_public_path__ + "static/media/pin.1c5bf11a.svg";